var map = {
	"./google-play-badge-da-DK.svg": 29926,
	"./google-play-badge-de-DE.svg": 4404,
	"./google-play-badge-en-GB.svg": 66222,
	"./google-play-badge-en-US.svg": 39813,
	"./google-play-badge-es-ES.svg": 12190,
	"./google-play-badge-es-MX.svg": 81373,
	"./google-play-badge-fr-FR.svg": 2462,
	"./google-play-badge-it-IT.svg": 91740,
	"./google-play-badge-nb-NO.svg": 38371,
	"./google-play-badge-nl-NL.svg": 96570,
	"./google-play-badge-pl-PL.svg": 43890,
	"./google-play-badge-pt-BR.svg": 85438,
	"./google-play-badge-pt-PT.svg": 48466,
	"./google-play-badge-sv-SE.svg": 64223
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31724;